import React, { useEffect, useMemo, useState } from 'react'

import { EffectBackgroundProps } from '../types'

export const SpotlightEffect = React.memo(({ layerStyle, index, values }: EffectBackgroundProps) => {
  const effectColors = useMemo(() => values.effectColors || ['#ffffff'], [values.effectColors])
  const effectSpeed = values.effectSpeed ?? 100
  const effectOpacity = values.effectOpacity ?? 100
  const effectBackgroundColor = values.effectBackgroundColor || '#000000'
  const opacityValue = effectOpacity / 100

  const spotlightSize = 300
  const intensity = 50
  const spotlightColor1 = effectColors[0] || '#ffffff'
  const spotlightColor2 = effectColors[1] || effectColors[0] || '#ffffff'

  const [mousePosition, setMousePosition] = useState({ x: 50, y: 50 })
  const [spotlightPosition, setSpotlightPosition] = useState({ x: 50, y: 50 })

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const x = (e.clientX / window.innerWidth) * 100
      const y = (e.clientY / window.innerHeight) * 100
      setMousePosition({ x, y })
    }

    window.addEventListener('mousemove', handleMouseMove)
    return () => window.removeEventListener('mousemove', handleMouseMove)
  }, [])

  useEffect(() => {
    const interval = setInterval(() => {
      setSpotlightPosition((prev) => ({
        x: prev.x + (mousePosition.x - prev.x) * (0.1 * (effectSpeed / 100)),
        y: prev.y + (mousePosition.y - prev.y) * (0.1 * (effectSpeed / 100)),
      }))
    }, 16)

    return () => clearInterval(interval)
  }, [mousePosition, effectSpeed])

  return (
    <div
      style={{
        position: 'absolute' as const,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -index - 1,
        overflow: 'hidden',
        backgroundColor: effectBackgroundColor,
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `radial-gradient(${spotlightSize * 2}px at ${spotlightPosition.x}% ${spotlightPosition.y}%, ${spotlightColor1}, ${spotlightColor2} ${intensity}%, transparent 100%)`,
          opacity: opacityValue,
          transition: 'all 0.1s ease-out',
        }}
      />
    </div>
  )
})
SpotlightEffect.displayName = 'SpotlightEffect'
